import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { auth } from '../api';
import { Icon } from './Icon';

export function SignOutButton({ className = 'hdr-btn', iconOnly = false }: { className?: string; iconOnly?: boolean }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const signOut = async () => {
    try {
      await auth.logout();
    } finally {
      queryClient.clear();
      navigate('/sign-in', { replace: true });
    }
  };
  return (
    <button type="button" className={className} title={t('header.signOut')} aria-label={t('header.signOut')} onClick={() => void signOut()}>
      <Icon name="logout" />
      {iconOnly ? null : t('header.signOut')}
    </button>
  );
}
